// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-details-usage-history-chart.chart-container[data-v-9f63dcc8] {
  padding: 10px 15px 0;
}`, "",{"version":3,"sources":["webpack://./js/modules/historical/user-details-view/charts/userDetailsUsageHistoryChart.vue","webpack://./userDetailsUsageHistoryChart.vue"],"names":[],"mappings":"AACA;EACE,oBAAA;ACAF","sourcesContent":["\n.user-details-usage-history-chart.chart-container {\n  padding: 10px 15px 0;\n}\n",".user-details-usage-history-chart.chart-container {\n  padding: 10px 15px 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
